import FeedModule from "modules/Core/core-modules/FeedModule";
import { CYCLES } from "../consts";
import middleware from "../middleware";

export default new FeedModule({
  name: CYCLES,
  cellOptions: {
    createEntityCell: {
      requestHandler: middleware.ops.create,
    },
    fetchEntityCell: {
      requestHandler: middleware.ops.fetchEntity,
    },
    fetchFeedCell: {
      requestHandler: middleware.ops.fetchFeed,
    },
  },
});
